// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file auditlog_event_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file auditlog_event_type.proto.
 */
export const file_auditlog_event_type: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum domain.AuditlogEventType
 */
export enum AuditlogEventType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: AUDITLOG_EVENT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_AUTOFILL = 1;
   */
  LOGIN_R_AUTOFILL = 1,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_PASSWORD_SHOW = 100;
   */
  LOGIN_R_PASSWORD_SHOW = 100,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_PASSWORD_COPY = 101;
   */
  LOGIN_R_PASSWORD_COPY = 101,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_PASSWORD_INSERT_CONTEXT_MENU = 102;
   */
  LOGIN_R_PASSWORD_INSERT_CONTEXT_MENU = 102,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_CUSTOM_FIELD_SHOW = 200;
   */
  LOGIN_R_CUSTOM_FIELD_SHOW = 200,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_CUSTOM_FIELD_COPY = 201;
   */
  LOGIN_R_CUSTOM_FIELD_COPY = 201,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_CUSTOM_FIELD_INSERT_CONTEXT_MENU = 202;
   */
  LOGIN_R_CUSTOM_FIELD_INSERT_CONTEXT_MENU = 202,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_R_TOTP_SECRET_SHOW = 300;
   */
  LOGIN_R_TOTP_SECRET_SHOW = 300,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_SECURITY_CODE_SHOW = 400;
   */
  CREDIT_CARD_R_SECURITY_CODE_SHOW = 400,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_SECURITY_CODE_COPY = 401;
   */
  CREDIT_CARD_R_SECURITY_CODE_COPY = 401,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_PIN_SHOW = 402;
   */
  CREDIT_CARD_R_PIN_SHOW = 402,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_PIN_COPY = 403;
   */
  CREDIT_CARD_R_PIN_COPY = 403,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_SECURITY_CODE_INSERT_CONTEXT_MENU = 404;
   */
  CREDIT_CARD_R_SECURITY_CODE_INSERT_CONTEXT_MENU = 404,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_CREDIT_CARD_R_PIN_INSERT_CONTEXT_MENU = 405;
   */
  CREDIT_CARD_R_PIN_INSERT_CONTEXT_MENU = 405,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_WIFI_R_QR_SHOW = 500;
   */
  WIFI_R_QR_SHOW = 500,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_CREATE = 10001;
   */
  LOGIN_W_CREATE = 10001,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_CHANGE = 10002;
   */
  LOGIN_W_CHANGE = 10002,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_DELETE = 10003;
   */
  LOGIN_W_DELETE = 10003,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_ARCHIVE = 10004;
   */
  LOGIN_W_ARCHIVE = 10004,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_RESTORE_FROM_ARCHIVE = 10005;
   */
  LOGIN_W_RESTORE_FROM_ARCHIVE = 10005,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_W_MOVE = 10006;
   */
  LOGIN_W_MOVE = 10006,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_SHARE_LINK_CREATE = 20001;
   */
  LOGIN_SHARE_LINK_CREATE = 20001,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_CREATE = 30001;
   */
  PROFILE_CREATE = 30001,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_DELETE = 30002;
   */
  PROFILE_DELETE = 30002,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_CLAIM_WITH_START_CODE = 30003;
   */
  PROFILE_CLAIM_WITH_START_CODE = 30003,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_DISCONNECT = 30004;
   */
  PROFILE_DISCONNECT = 30004,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_PROMOTE_TO_ADMIN = 30005;
   */
  PROFILE_PROMOTE_TO_ADMIN = 30005,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_PROFILE_DEMOTE_ADMIN = 30006;
   */
  PROFILE_DEMOTE_ADMIN = 30006,

  /**
   * TODO implement
   * AUDITLOG_EVENT_TYPE_LOGIN_SHARE_SECRET_GET = 20003;
   *
   * @generated from enum value: AUDITLOG_EVENT_TYPE_LOGIN_SHARE_SECRET_CREATE = 20002;
   */
  LOGIN_SHARE_SECRET_CREATE = 20002,
}

/**
 * Describes the enum domain.AuditlogEventType.
 */
export const AuditlogEventTypeSchema: GenEnum<AuditlogEventType> = /*@__PURE__*/
  enumDesc(file_auditlog_event_type, 0);

/**
 * @generated from enum domain.AuditlogEventTypeGroup
 */
export enum AuditlogEventTypeGroup {
  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_GROUP_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_GROUP_LOGIN_MIN = 1;
   */
  LOGIN_MIN = 1,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_GROUP_LOGIN_MAX = 29999;
   */
  LOGIN_MAX = 29999,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_GROUP_PROFILE_MIN = 30001;
   */
  PROFILE_MIN = 30001,

  /**
   * @generated from enum value: AUDITLOG_EVENT_TYPE_GROUP_PROFILE_MAX = 39999;
   */
  PROFILE_MAX = 39999,
}

/**
 * Describes the enum domain.AuditlogEventTypeGroup.
 */
export const AuditlogEventTypeGroupSchema: GenEnum<AuditlogEventTypeGroup> = /*@__PURE__*/
  enumDesc(file_auditlog_event_type, 1);

